import React, { Component } from 'react'
import ContentAdd from 'material-ui/svg-icons/content/add'
import Layout from '../../components/Layout'
import EditModal from './EditModal'
import ListTable from './ListTable'
import { connect } from 'react-redux'
import { withStyles } from '@material-ui/core/styles'
import { userActions, searchTableActions } from '../../actions'
import Typography from '@material-ui/core/Typography'
import jwt_decode from 'jwt-decode'
import CrudHeader from '../../components/CrudHeader'
import { crudListStyle } from '../../styles'
import { Button } from '@material-ui/core'
import UserToolbar from '../../components/UserToolbar'

class Users extends Component {
  state = {
    modalOpen: false
  }

  componentWillUnmount() {
    const { resetState } = this.props
    resetState()
  }

  render() {
    const { modalOpen, openModal, closeModal, newFormUser, classes, token } = this.props
    const userToken = jwt_decode(token)

    return (
      <Layout toolBarRight={UserToolbar}>
        <CrudHeader
          title={'Usuários'}
          classes={classes}
          newResource={newFormUser}
          openModal={openModal}
          token={token}
          functionality={'usuarios'}
        />
        <EditModal open={modalOpen} onClose={closeModal} />
        <ListTable />
      </Layout>
    )
  }
}

const mapStateToProps = state => {
  return { modalOpen: state.user.modalOpen, token: state.auth.token }
}

const mapDispatchToProps = dispatch => {
  return {
    openModal: () => {
      dispatch(userActions.openModal())
    },
    closeModal: () => {
      dispatch(userActions.closeModal())
    },
    newFormUser: user => {
      dispatch(userActions.newFormUser(user))
    },
    resetState: () => {
      dispatch(userActions.resetState())
    }
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withStyles(crudListStyle)(Users))



// WEBPACK FOOTER //
// ./src/containers/Users/index.js